import React, { useEffect } from 'react'

const ExportData = (props) => {
  

  const calculateColumnTotal = (data, property) => {
    return parseFloat(data?.reduce((accumulator, current) => parseFloat(accumulator) + parseFloat(current[property] ? current[property] : 0), 0)).toFixed(2)
  }

  useEffect(() => {
    console.log(props)
  }, [])

  return (
    <div className='d-none'>
      <table id="content_table" stickyHeader aria-label="sticky table">
        <thead>
          <tr>
            <td>Nr</td>
            <td style={{ width: '300px' }}>Punëtori</td>
            <td>Paga</td>
            <td>Avanci</td>
            <td>Orët shtesë</td>
            <td>Pagesa për Orë shtesë</td>
            <td>Kontributet</td>
            <td>Taksat</td>
            <td>Paga neto</td>
            <td>Bonuset</td>
            <td>Ndeshkimet</td>
            <td>Totali</td>
          </tr>
        </thead>
        <tbody>
          {props?.salaries?.map((w, index) => (w.status !== -1 &&
            <tr key={w.id + index}>
              <td>{index + 1}</td>
              <td>{props?.workers.find(i => i.id === w.WorkerId)?.name}</td>
              <td>{"€ " + (w.Salary || 0 )}</td>
              <td>{"€ " + (w.Advances || 0)}</td>
              <td>{"€ " + (w.ExtraHours + w.ExtraHoursWeekend + w.ExtraHoursHoliday || 0)}</td>
              <td>{"€ " + (w.HourSalary || 0)}</td>
              <td>{"€ " + (w?.contributions || 0)}</td>
              <td>{"€ " + (w?.taxes || 0)}</td>
              <td>{"€ " + (w?.neto || 0)}</td>
              <td>{"€ " + (w?.Bonus || 0)}</td>
              <td>{"€ " + (w?.Penalties || 0)}</td>
              <td>{"€ " + (w?.total || 0)}</td>
            </tr>
          ))}
          <tr className='d-none1' style={{ fontWeight: 'bold' }}>
            <td></td>
            <td></td>
            <td>{calculateColumnTotal(props?.salaries, 'Salary')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'Advances')}</td>
            <td>
              {
                parseFloat(parseFloat(calculateColumnTotal(props?.salaries, 'ExtraHours')) +
                  parseFloat(calculateColumnTotal(props?.salaries, 'ExtraHoursWeekend')) +
                  parseFloat(calculateColumnTotal(props?.salaries, 'ExtraHoursHoliday'))).toFixed(2)
              }
            </td>
            <td>{calculateColumnTotal(props?.salaries, 'HourSalary')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'contributions')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'taxes')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'neto')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'Bonus')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'Penalties')}</td>
            <td>{calculateColumnTotal(props?.salaries, 'total')}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ExportData